import TournamentAnalysisPage from "@/pages/tournament/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_pathlessLayout/tournament")({
    component: TournamentAnalysisPage,
});
